import { render, staticRenderFns } from "./PlantasForrageirasInstitucional.vue?vue&type=template&id=317b5bc8&"
import script from "./PlantasForrageirasInstitucional.vue?vue&type=script&lang=js&"
export * from "./PlantasForrageirasInstitucional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports